var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"submit"},on:{"click":_vm.buttonClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_c('i',{staticClass:"icon fleet-arrow-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }